module.exports = "/_next/static/images/775c43e180da1c83a3d96bc34554187d-pregnant-woman@desktop@2x.jpg.webp";